const isFiscal = (
  period: FixedPeriods.ExtendedPeriod,
): period is FixedPeriods.BaseFiscalPeriod => period.type === 'fiscal';

const isFiscalPeriod = (
  period: FixedPeriods.ExtendedPeriod,
): period is FixedPeriods.FiscalPeriod =>
  isFiscal(period) && period.fiscalType === 'fiscalPeriod';

const isFiscalQuarter = (
  period: FixedPeriods.ExtendedPeriod,
): period is FixedPeriods.FiscalQuarter =>
  isFiscal(period) && period.fiscalType === 'fiscalQuarter';

const isFiscalYear = (
  period: FixedPeriods.ExtendedPeriod,
): period is FixedPeriods.FiscalYear =>
  isFiscal(period) && period.fiscalType === 'fiscalYear';

const fiscalPeriodTypeCheckers = {
  isFiscalYear,
  isFiscalQuarter,
  isFiscalPeriod,
};

export default fiscalPeriodTypeCheckers;
